import React from 'react';
import { useSsmUiFlags } from '@utilities/hooks/useSsmUiFlags/useSsmUiFlags';
import { registerServiceWorker } from '@utilities/serviceWorker/serviceWorkerUtils';

export const useInitializeServiceWorker = (): void => {
	const { wEnableServiceWorker } = useSsmUiFlags();

	React.useEffect(() => {
		if (!wEnableServiceWorker) {
			return;
		}

		void registerServiceWorker();
	}, [wEnableServiceWorker]);
};
